import React, { useState } from 'react';
import { formatCurrency, formatNumber } from '../../utils/formatters';
import '../../styles/Dashboard.css';

const TopProductos = ({ productos = [] }) => {
  const [paginaActual, setPaginaActual] = useState(1);
  const productosPorPagina = 5;

  if (!productos || productos.length === 0) {
    return (
      <div className="dashboard-widget">
        <h3 className="widget-title">Productos Más Vendidos (Últimos 3 Meses)</h3>
        <div className="widget-empty">
          <p>No hay datos de productos disponibles</p>
        </div>
      </div>
    );
  }

  // Calcular paginación
  const totalPaginas = Math.ceil(productos.length / productosPorPagina);
  const indiceInicio = (paginaActual - 1) * productosPorPagina;
  const indiceFin = indiceInicio + productosPorPagina;
  const productosPaginados = productos.slice(indiceInicio, indiceFin);

  const cambiarPagina = (nuevaPagina) => {
    if (nuevaPagina >= 1 && nuevaPagina <= totalPaginas) {
      setPaginaActual(nuevaPagina);
    }
  };

  return (
    <div className="dashboard-widget">
      <h3 className="widget-title">
        <span className="widget-icon">🏆</span>
        Productos Más Vendidos (Últimos 3 Meses)
      </h3>
      <div className="widget-body">
        <div className="top-productos-list">
          {productosPaginados.map((producto, index) => {
            const rankGlobal = indiceInicio + index + 1;
            return (
              <div key={producto.id || index} className="producto-item">
                <div className="producto-rank">#{rankGlobal}</div>
                <div className="producto-info">
                  <div className="producto-nombre">{producto.nombre}</div>
                  <div className="producto-stats">
                    <span className="stat-item">
                      <span className="stat-label">Vendidos:</span>
                      <span className="stat-value">{formatNumber(producto.cantidad_vendida)}</span>
                    </span>
                    <span className="stat-item">
                      <span className="stat-label">Total:</span>
                      <span className="stat-value">{formatCurrency(producto.total_ventas)}</span>
                    </span>
                  </div>
                </div>
                <div className="producto-progress">
                  <div
                    className="progress-bar"
                    style={{
                      width: `${(producto.cantidad_vendida / productos[0].cantidad_vendida) * 100}%`
                    }}
                  />
                </div>
              </div>
            );
          })}
        </div>
        
        {/* Paginación */}
        {totalPaginas > 1 && (
          <div className="pagination">
            <button
              className="pagination-btn"
              onClick={() => cambiarPagina(paginaActual - 1)}
              disabled={paginaActual === 1}
            >
              ← Anterior
            </button>
            <div className="pagination-center">
              <span className="pagination-info">
                Página {paginaActual} de {totalPaginas}
              </span>
              <span className="pagination-total">
                Total de registros: {productos.length}
              </span>
            </div>
            <button
              className="pagination-btn"
              onClick={() => cambiarPagina(paginaActual + 1)}
              disabled={paginaActual === totalPaginas}
            >
              Siguiente →
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default TopProductos;

// Made with Bob
